export default function Tooltip(theme) {
    return {
        MuiTooltip: {
            defaultProps: {
                enterTouchDelay: 50,
                leaveTouchDelay: 10000,
                arrow: true,
                slotProps: {
                    popper: {
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [
                                        0,
                                        -5
                                    ]
                                }
                            }
                        ]
                    }
                }
            },
            styleOverrides: {
                tooltip: {
                    backgroundColor: theme.palette.grey.A700
                },
                arrow: {
                    color: theme.palette.grey.A700
                }
            }
        }
    };
}
